import { useContext } from "react";
import { DataContext } from "../../../context/DataContext.jsx";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { petitions } from "../../../api/calls.js";

export default function SettingsUsuario() {
  const { session, user, saveUser } = useContext(DataContext);

  const form1 = useForm({
    defaultValues: {
      idUsuario: user?.idUsuario ?? "",
      nroDoc: user?.nroDoc ?? "",
      apellidos: user?.apellidos ?? "",
      nombres: user?.nombres ?? "",
      tipUsu: (user?.tipUsu ?? "") === "A" ? "Administrador" : "Usuario común",
      nota: user?.nota ?? "",
      correo: user?.correo ?? "",
      telefono: user?.telefono ?? "",
    },
  });

  const getDniSunat = async () => {
    const dniruc = form1.getValues("nroDoc");
    if (!dniruc || dniruc.length < 8) {
      toast.warning("El número de documento debe tener al menos 8 dígitos");
      return;
    }
    if (dniruc.length > 11) {
      toast.warning("El número de documento no puede tener más de 11 dígitos");
      return;
    }

    const response = await petitions.getDni(dniruc, session().token);
    if (response.data?.success) {
      form1.setValue("nombres", response.data.nombres, {
        shouldValidate: true,
      });
      form1.setValue(
        "apellidos",
        `${response.data.apellidoPaterno} ${response.data.apellidoMaterno}`,
        { shouldValidate: true }
      );
    } else {
      toast.warning("Documento con el número " + dniruc + " no encontrado");
    }
  };

  const updateUsuario = form1.handleSubmit(async (data) => {
    const response = await petitions.updateUsuario(session().token, data);

    if (response.status === "success") {
        toast.success("Usuario actualizado correctamente");
        await saveUser(data.idUsuario, session().token);
    } else {
      var msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  return (
    <>
      <h2 className="mb-4">Información de cuenta</h2>
      <div className="row">
        <div className="col-xl-9">
          <form className="row g-3 mb-6" onSubmit={updateUsuario}>
            <div className="col-sm-6 col-md-1 me-4">
              <button
                className="btn btn-primary rounded-4"
                type="button"
                onClick={() => getDniSunat()}
              >
                <span className="fas fa-search fs-6"></span>
              </button>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputGrid"
                  type="number"
                  placeholder="Project title"
                  {...form1.register("nroDoc", {
                    required: {
                      value: true,
                      message: "El número de documento es requerido",
                    },
                    maxLength: {
                      value: 11,
                      message: "DNI demasiado largo, máximo 11 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputGrid">Número de documento</label>
                {form1.formState.errors?.nroDoc && (
                  <code>{form1.formState.errors.nroDoc.message}</code>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputGrid"
                  type="text"
                  placeholder="Project title"
                  disabled={true}
                  value={session?.idUsuario ?? ""}
                  {...form1.register("tipUsu")}
                />
                <label htmlFor="floatingInputGrid">Tipo de usuario</label>
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputGrid"
                  type="text"
                  placeholder="Project title"
                  {...form1.register("nombres", {
                    required: {
                      value: true,
                      message: "Los nombres son requeridos",
                    },
                    maxLength: {
                      value: 50,
                      message: "Nombres demasiado largos, máximo 50 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputGrid">Nombres</label>
                {form1.formState.errors?.nombres && (
                  <code>{form1.formState.errors.nombres.message}</code>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputGrid"
                  type="text"
                  placeholder="Project title"
                  {...form1.register("apellidos", {
                    required: {
                      value: true,
                      message: "Los apellidos son requeridos",
                    },
                    maxLength: {
                      value: 50,
                      message:
                        "Apellidos demasiado largos, máximo 50 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputGrid">Apellidos</label>
                {form1.formState.errors?.apellidos && (
                  <code>{form1.formState.errors.apellidos.message}</code>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputGrid"
                  type="text"
                  placeholder="Project title"
                  {...form1.register("telefono", {
                    required: {
                      value: true,
                      message: "El número de celular es requerido",
                    },
                    maxLength: {
                      value: 9,
                      message:
                        "Número de celular demasiado largo, máximo 9 dígitos",
                    },
                  })}
                />
                <label htmlFor="floatingInputGrid">Celular</label>
                {form1.formState.errors?.telefono && (
                  <code>{form1.formState.errors.telefono.message}</code>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-5">
              {user.bloqueado === "S" ? (
                <div
                  className="alert alert-outline-danger d-flex align-items-center py-1 px-4 mb-1 rounded-4"
                  role="alert"
                  style={{ height: "48px" }}
                >
                  <span className="fas fa-times-circle text-danger fs-6 me-2"></span>
                  <span className="mb-0 small flex-1">
                    Tu usuario está bloqueado.
                  </span>
                </div>
              ) : (
                <div
                  className="alert alert-outline-success d-flex align-items-center py-1 px-4 mb-1 rounded-4"
                  role="alert"
                  style={{ height: "48px" }}
                >
                  <span className="fas fa-check-circle text-success fs-6 me-2"></span>
                  <span className="mb-0 small flex-1">
                    Tu usuario se encuentra activo.
                  </span>
                </div>
              )}
            </div>
            <div className="col-sm-6 col-md-7">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputGrid"
                  type="text"
                  placeholder="Project title"
                  {...form1.register("correo", {
                    required: {
                      value: true,
                      message: "El correo es requerido",
                    },
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Correo electrónico inválido",
                    },
                  })}
                />
                <label htmlFor="floatingInputGrid">Correo</label>
              </div>
              {form1.formState.errors?.correo && (
                <code>{form1.formState.errors.correo.message}</code>
              )}
            </div>
            <div className="col-12 gy-5">
              <div className="form-floating">
                <textarea
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingProjectOverview"
                  placeholder="Leave a comment here"
                  style={{ height: "100px" }}
                  rows="3"
                  {...form1.register("nota", {
                    maxLength: {
                      value: 255,
                      message: "Nota demasiada larga",
                    },
                  })}
                  defaultValue=""
                ></textarea>
                <label htmlFor="floatingProjectOverview">Nota</label>
                {form1.formState.errors?.nota && (
                  <div className="invalid-feedback">
                    {form1.formState.errors.nota.message}
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 gy-6">
              <div className="row g-3 justify-content-end">
                <div className="col-auto">
                  <button
                    className="btn btn-phoenix-primary px-5 rounded-4"
                    disabled={true}
                  >
                    Cancelar
                  </button>
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-primary px-5 px-sm-15 rounded-4"
                    type="submit"
                  >
                    Actualizar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
